import { createContext } from 'react';

export const MedicamentosTramitesContext = createContext();
